import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedProductsSection from './components/FeaturedProductsSection';
import RegionsSection from './components/RegionsSection';
import WhiskiesSection from './components/WhiskiesSection';
import GinsSection from './components/GinsSection';
import BrandSection from './components/BrandSection';
import NewsletterSection from './components/NewsletterSection';

const HomePage = () => {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedProductsSection />
        <RegionsSection />
        <WhiskiesSection />
        <GinsSection />
        <BrandSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
